import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import entry from '@/components/entry'
import login from '@/components/user/login'
import usercenter from '@/components/user/center/center'
import register from '@/components/user/register'
import viewIndex from '@/components/view/index'
import comicshow from '@/components/comic/show'
import comiclist from '@/components/comic/list'
import contactus from '@/components/other/contactus'
import aboutus from '@/components/other/aboutus'
import buy_vip from '@/components/buy/vip'
import buy_gold from '@/components/buy/gold'
import release_comic from '@/components/release/comic'
import forum_index from '@/components/forum/index'
import release_thread from '@/components/release/thread'
import Meta from 'vue-meta'
import VueAnalytics from 'vue-analytics'


const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Meta)
Vue.use(Router)


let router = new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '成人漫画,H韩国漫画,H日本漫画',
      content: {
        keywords: '成人漫画,H漫画,H日本漫画,H韩国漫画',
        description: '在线看成人漫画,H日本漫画,H韩国漫画',
      },
    }
  },
    {
      path: '/view/:id',
      name: 'view',
      component: viewIndex,
      meta: {
        title: ''
      },
      beforeRouteUpdate(to, from, next) {
        console.log(to.params.id);
        next();
      }
    },
    {
      path: '/user/login',
      name: 'login',
      component: login,
      meta: {
        title: '登录'
      }
    },
    {
      path: '/user/register',
      name: 'register',
      component: register,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/user/settings',
      name: 'user_center',
      component: usercenter,
      meta: {
        title: '个人设置',
        action: "settings"
      }
    },
    {
      path: '/user/:id',
      name: 'user_center',
      component: usercenter,
      meta: {
        title: '个人主页'
      }
    },
    {
      path: '/comic/list',
      name: 'comiclist',
      component: comiclist,
      meta: {
        title: ''
      }
    },
    {
      path: '/comic/:id',
      name: 'comicshow',
      component: comicshow,
      meta: {
        title: ''
      }
    },
    {
      path: '/buy/vip',
      name: 'buy_vip',
      component: buy_vip,
      meta: {
        title: '升级VIP'
      }
    },
    {
      path: '/buy/gold',
      name: 'buy_gold',
      component: buy_gold,
      meta: {
        title: '充值金币'
      }
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: contactus,
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus,
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/release/comic',
      name: 'release_comic',
      component: release_comic,
      meta: {
        title: '漫画投稿'
      }
    },
    {
      path: '/forum',
      name: 'forum_index',
      component: forum_index,
      meta: {
        title: '社区'
      }
    },
    {
      path: '/release/thread',
      name: 'release_thread',
      component: release_thread,
      meta: {
        title: '发布'
      }
    },
    {
      path: '/website',
      name: 'entry',
      component: entry,
      meta: {
        title: '网址发布'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({x: 0, y: 0})
      }, 500)
    })
  }
})


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
    Vue.prototype.set_title(to.meta.title);
  }
  next()
});


Vue.prototype.set_keywords = function (keywords) {
  document.querySelector('meta[name="keywords"]').setAttribute('content', keywords);
}

Vue.prototype.add_keywords = function (keywords) {
  var orginal_keywords = document.querySelector('meta[name="keywords"]').getAttribute('content');
  if (orginal_keywords && orginal_keywords.length > 0) {
    orginal_keywords += "," + keywords;
  } else {
    orginal_keywords = keywords;
  }
  document.querySelector('meta[name="keywords"]').setAttribute('content', orginal_keywords);
}

Vue.prototype.set_description = function (description) {
  document.querySelector('meta[name="description"]').setAttribute('content', description);
}

Vue.prototype.add_description = function (description) {
  var orginal_description = document.querySelector('meta[name="description"]').getAttribute('content');
  if (orginal_description && orginal_description.length > 0) {
    orginal_description += "," + description;
  } else {
    orginal_description = description;
  }
  document.querySelector('meta[name="description"]').setAttribute('content', orginal_description);
}


Vue.use(VueAnalytics, {
  id: 'UA-169931030-2',
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})

export default router